import { render, staticRenderFns } from "./projectLomSideView.vue?vue&type=template&id=62b339a7"
import script from "./projectLomSideView.vue?vue&type=script&lang=js"
export * from "./projectLomSideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports